import { IntegrationV2ResponseSchema } from "@redotech/internal-ctx-client";
import * as z from "zod/v4";

export const getContextualIntegration = {
  name: "getContextualIntegration" as const,
  input: z.object({ integrationId: z.string() }),
  output: IntegrationV2ResponseSchema,
};
